import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_snackbar = _resolveComponent("v-snackbar")

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    "model-value": _ctx.isSnackbarShowing,
    "onUpdate:modelValue": _ctx.setShowing,
    timeout: 10000,
    color: _ctx.color,
    "multi-line": ""
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "white",
        variant: "text",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.setShowing(false)))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Close ", -1)
        ]))]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.message) + " ", 1)
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "color"]))
}